module.exports = __webpack_public_path__ + "uia-approve-for-fanreel.21b14835f4f6708ab7c2936bdcf3711f.svg";